/** entities/portfolio 의 화면 글자 */
export const PORTFOLIO_ROW_TEXT = {
  header: {
    portfolioName: '회사명',
    fundName: '펀드명',
    investAt: '투자일',
    investVolume: '투자금액',
    valuation: '평가/회수금액',
    valuatedAt: '평가/회수일',
    irr: 'IRR',
    multiple: 'Multiple',
    internalManagerName: '담당심사역',
    revenueHistory: '매출',
    stockPriceHistory: '기업가치',
  },
  revenueChart: (name: string) => `${name} 매출 추이`,
  stockPriceChart: (name: string) => `${name} 기업가치 추이`,
} as const;

/** 금액 단위: KRW 는 백만원, USD 는 K$ — 둘 다 숫자와 띄어 쓴다(DD-13 G12, 기존 서비스 "100 K$") */
export const AMOUNT_UNIT_TEXT = {
  KRW: ' 백만원',
  USD: ' K$',
} as const;

export const SEARCH_RESULT_TEXT = {
  memo: (datetime: string) => `메모 (${datetime})`,
  report: (datetime: string) => `영업현황 (${datetime})`,
  round: (datetime: string) => `연관 파트너 (${datetime})`,
  ellipsis: '...',
} as const;
